export default "__VITE_ASSET__BIN_ynHz__"